module.exports = __webpack_public_path__ + "img/stock_zone@2x.9d0f5504.png";